module.exports = __webpack_public_path__ + "img/experience_de.320a8a5d.svg";